module.exports = __webpack_public_path__ + "static/img/download.58ba3faa.svg";